import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import Vue from 'vue'
import App from './App'
import store from './store'
import unieditor from '@/components/index.js'
Vue.use(unieditor)
// main.js
Vue.config.productionTip = false
App.mpType = 'app'
Vue.prototype.$store = store

//微信公众号jsapi相关
//






const app = new Vue({
	store,
	...App
})
app.$mount()